import { DISPLAY_FREE, GET_FREE, UPDATE_CHAT } from "../actions/types";

const initialState = {
  displayFree: false,
  freeUrl: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DISPLAY_FREE:
      return {
        ...state,
        displayFree: action.payload,
      };
    case GET_FREE:
      return {
        ...state,
        freeUrl: action.payload.freeUrl,
      };

    default:
      return state;
  }
}
